<script lang="ts">
  import { page } from '$app/stores';
  import PrimaryNav from '$components/GlobalNav/PrimaryNav.svelte';
  import GlobalNav from '$components/GlobalNav/GlobalNav.svelte';
  import { flagValue } from '$lib/context/flags';
  import { FEATURE_FLAGS } from '$lib/flags/constants';

  $: globalNavEnabled = flagValue(FEATURE_FLAGS.GLOBAL_NAV);
  $: isCareersPage = $page.route.id?.startsWith('/[[language=language]]/(with-nav)/careers');
</script>

{#if globalNavEnabled}
  <GlobalNav />
{:else}
  <PrimaryNav border={isCareersPage} fixed={!isCareersPage} />
{/if}
